export function createPageState(overrides = {}) {
	return {
		cursor: '',
		more: false,
		total: 0,
		loading: false,
		error: false,
		...(overrides || {})
	};
}

export function createSyncState(overrides = {}) {
	return {
		rev: 0,
		base: 0,
		...(overrides || {})
	};
}

export function resetPageState(page, overrides = {}) {
	if (!page) {
		return page;
	}
	page.cursor = '';
	page.more = false;
	page.total = 0;
	page.loading = false;
	page.error = false;
	Object.assign(page, overrides || {});
	return page;
}

export function applyPageState(pageState, page, fallbackTotal = 0) {
	if (!pageState) {
		return false;
	}
	const more = Boolean(page && page.more && page.cursor);
	const pageTotal = Number(page && page.total);
	const total = Number.isFinite(pageTotal) ? pageTotal : fallbackTotal;
	pageState.more = more;
	pageState.total = Math.max(0, Math.floor(total || 0));
	pageState.cursor = more ? String(page.cursor) : '';
	return more;
}

export function applySyncPageState(pageState, syncState, page, baseRev, toRev) {
	const more = applyPageState(pageState, page, pageState && pageState.total);
	if (!syncState) {
		return more;
	}
	syncState.base = toRev(baseRev);
	if (!more) {
		syncState.rev = toRev(page && page.rev);
		syncState.base = syncState.rev;
	}
	return more;
}
